// extracted by mini-css-extract-plugin
module.exports = {"boxWrap":"Box_boxWrap__14HPx","boxContainer":"Box_boxContainer__33UmJ"};